import { render, staticRenderFns } from "./VMobileTabs.vue?vue&type=template&id=d76dbfc6&scoped=true&lang=pug"
import script from "./VMobileTabs.vue?vue&type=script&lang=js"
export * from "./VMobileTabs.vue?vue&type=script&lang=js"
import style0 from "./VMobileTabs.vue?vue&type=style&index=0&id=d76dbfc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76dbfc6",
  null
  
)

export default component.exports